import { Component, createElement } from 'react';
import { isEmpty } from 'lodash/fp';
import { TYPES } from 'constants/config';
import PathRenderer from './PathRenderer.js';
import ContentGroup from './ContentGroup';
import DemonstrationBody from './DemonstrationBody';
import LessonBody from './LessonBody';
import PathBody from './PathBody';

const EMPTY_PATH_WARNING =
  'This embedded Path contains no Lessons and will not be visible to Learners.';

const Path = props =>
  new PathRenderer({
    pathComponent: PathBody,
    groupComponent: ContentGroup,
    startingPosition: props.stepNumber,
    pathData: props,
    getEmptyPathProps: path =>
      !path.loading && {
        warning: EMPTY_PATH_WARNING,
      },
  });

const typeToComponentMap = {
  [TYPES.LESSON]: LessonBody,
  [TYPES.PATH]: Path,
  [TYPES.DEMONSTRATION]: DemonstrationBody,
};

class ContentRenderer extends Component {
  componentDidMount() {
    if (this.props.type === TYPES.PATH && !this.hasContents()) {
      this.props.fetchContents();
    }
  }

  hasContents() {
    return !isEmpty(this.props.contents);
  }

  render() {
    return createElement(typeToComponentMap[this.props.type], this.props);
  }
}

export default ContentRenderer;
